import React, { useEffect, useRef, useState } from 'react'
import AuthContainer from '../../components/auth/AuthContainer'
import AuthHeader from '../../components/auth/AuthHeader'
import CustomButton from '../../utils/CustomButton'
import '../../assets/styles/authStyles.css';
import OtpInput from '../../utils/OtpInput'
import { showError, showSuccess } from '../../utils/Toast';
import { connect, useSelector } from 'react-redux';
import { getResetOtp, verifyResetOtp } from '../../redux/actions/AuthActions';
import { useLocation, useNavigate } from 'react-router-dom';

const ForgotPasswordOtp = (props) => {

    const [pin, setPin] = useState('');
    const onChange = (value) => { setPin(value) };
    const Ref = useRef(null);
    const [timer, setTimer] = useState('00:00');
    const params = useLocation()
    const role = params?.state?.role
    const token = params?.state?.token
    const email = params?.state?.email
    const [state, setState] = useState({
        token: ''
    })

    const { verifyingOtp } = useSelector(state => state.auth)
    const navigate = useNavigate()
    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        return {
            total, minutes, seconds
        };
    }
    const startTimer = (e) => {
        let { total, minutes, seconds }
            = getTimeRemaining(e);
        if (total >= 0) {
            setTimer(
                (minutes > 9 ? minutes : '0' + minutes) + ':'
                + (seconds > 9 ? seconds : '0' + seconds)
            )
        }
    }
    const clearTimer = (e) => {
        setTimer('01:30');
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }
    const getDeadTime = () => {
        let deadline = new Date();
        deadline.setSeconds(deadline.getSeconds() + 90);
        return deadline;
    }

    useEffect(() => {
        clearTimer(getDeadTime());

    }, []);

    const onClickReset = () => {
        clearTimer(getDeadTime());
        requestOTP()
    }


    const requestOTP = async () => {
        const obj = { email }
        try {
            const res = await props.getResetOtp(obj)
            // console.log('request otp', res)
            showSuccess(res?.message);
            setState((prevState) => ({ ...prevState, token: res?.data?.authToken }))
        } catch (error) {
            // console.log('request otp', error)
            showError(error[1].message)
        }
    }

    const verifyOTP = async () => {

        if (state.token) {
            const obj = { otp: pin, token: state.token }
            try {
                const res = await props.verifyResetOtp(obj)
                // console.log('request otp', res)
                showSuccess(res?.message);
                navigate('/resetPassword', {
                    state: { token: res?.data?.authToken }
                })
            } catch (error) {
                // console.log('request otp', error)
                showError(error[1].message)
            }
        }
        if (token) {
            const obj = { otp: pin, token }
            try {
                const res = await props.verifyResetOtp(obj)
                // console.log('request otp', res)
                showSuccess(res?.message);
                navigate('/resetPassword', {
                    state: { token: res?.data?.authToken }
                })
            } catch (error) {
                // console.log('request otp', error)
                showError(error[1].message)
            }
        }

    }

    const renderSubtitle = () => {
        if (role === 'ADMIN') {
            return 'Enter OTP sent to your email address to continue'
        } else {
            return 'Enter OTP received from your line manager to continue'
        }
    }

    const renderTimer = () => {
        if (role === 'ADMIN') {
            return (
                <div style={{ marginBottom: '52px' }} className={'otpVerifyBtn'}>
                    <p className={'textCenter semiBoldText f14'}>Didn’t receive OTP?
                        {timer != '00:00' ? <span className={'semiBoldText f14'}> Resend OTP in {timer}</span> :
                            <span className={'semiBoldText f14'} style={{ color: '#FFA024' }} onClick={onClickReset}> Resend OTP </span>}
                    </p>
                </div>
            )
        } else {
            return null
        }
    }


    const disabled = () => {
        if (pin === '') {
            return true
        }
        return false
    }


    return (
        <>
            <AuthContainer logo={true}>
                <AuthHeader title={'Forgot password'} subTitle={renderSubtitle()} />
                <div style={{ marginBottom: '28px' }}>
                    <p className={'f14 semiBoldText'} style={{ color: '#08080C', marginBottom: '8px' }}>OTP</p>
                    <OtpInput value={pin} valueLength={6} onChange={onChange} />
                </div>
                {renderTimer()}
                <div className={'otpVerifyBtn'}>
                    <CustomButton title={'Verify'} onClick={verifyOTP} loading={verifyingOtp} disabled={disabled()} bgColor={'#FFA024'} />
                </div>
            </AuthContainer>
        </>
    )
}

export default connect(null, { getResetOtp, verifyResetOtp })(ForgotPasswordOtp);



